export enum EUserType {
  Unknown = 0,
  LemonLegacyUser = 1,
  LemonUpgradedUser = 2,
  TTUser = 3,
}

export const UserTypeUtil = {
  getLinkNamePrefix: (type: EUserType): '' | '@' =>
    [EUserType.Unknown, EUserType.LemonLegacyUser].includes(type) ? '' : '@',
  getLinkNamePrefixByBelongTT: (belongTT: boolean): '' | '@' => {
    return belongTT ? '@' : '';
  },
};
